import React, { useEffect, useState } from 'react';
import { Button, Input, Card, CardBody, CardHeader, FormGroup, Label, Form, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';
import InputMask from 'react-input-mask';
import { api } from "../../config";
import { fetchComAuth, fetchComAuthJson } from '../../common/api';

const TelaComercialFeira = ({ feiraId, editando }) => {
  const [comerciais, setComerciais] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [whatsapp_principal, setWhatsapp] = useState('');

  useEffect(() => {
    const carregarComerciaisSalvos = async () => {
      if (!feiraId) return;
  
      try {
        const response = await fetchComAuth(`${api.API_URL}/feira/comerciais/${feiraId}`, {
          method: 'GET'
        })
        
        const data = await response.json();
        setComerciais(data.data);
        
      } catch (err) {
        console.error("Erro ao carregar comerciais da feira", err);
      }
    };
    
    if (editando)
      carregarComerciaisSalvos();
  }, [feiraId]);

  const limparFormulario = () => {
    setNome('');
    setEmail('');
    setTelefone('');
    setWhatsapp('');
    setEditandoId(null);
  };

  const handleSalvar = () => {
    const payload = {
      id: editandoId,
      feira_id: feiraId,
      nome,
      email,
      telefone,
      whatsapp_principal
    };

    const metodo = editandoId ? 'PUT' : 'POST';
    fetchComAuthJson(`${api.API_URL}/comercial`, {
      method: metodo,
      body: JSON.stringify(payload)
    })
      .then(res => res.ok ? fetch(`${api.API_URL}/feira/comerciais/${feiraId}`) : Promise.reject('Erro ao salvar'))
      .then(res => res.json())
      .then(data => {
        setComerciais(data.data);
        setModalAberto(false);
        limparFormulario();
      })
      .catch(err => console.error('Erro ao salvar comercial:', err));
  };

  const handleEditar = (comercial) => {
    setNome(comercial.nome);
    setEmail(comercial.email);
    setTelefone(comercial.telefone);
    setWhatsapp(comercial.whatsapp_principal);
    setEditandoId(comercial.id);
    setModalAberto(true);
  };

  const handleExcluir = (id) => {
    fetchComAuth(`${api.API_URL}/feira/comercial/${id}`, {
      method: 'DELETE'
    })
      .then(res => res.ok ? fetch(`${api.API_URL}/feira/comerciais/${feiraId}`) : Promise.reject('Erro ao excluir'))
      .then(res => res.json())
      .then(data => setComerciais(data.data))
      .catch(err => console.error('Erro ao excluir comercial:', err));
  };

  return (
    <div>
        <Row>
            <Col lg={12}>
                <Card>
                    <CardHeader>
                        <Button color="success" onClick={() => { limparFormulario(); setModalAberto(true); }}>
                            <i className="ri-add-line align-bottom me-1"></i> Novo Comercial
                        </Button>
                    </CardHeader>
                    <CardBody>
                        <div className="table-responsive" id="comercialLista">
                            {comerciais.length === 0 ? (
                            <p className="text-muted">Nenhum comercial cadastrado ainda.</p>
                            ) : (
                            <Table className="table align-middle table-nowrap" >
                                <thead className="table-light">
                                <tr>
                                    <th>Nome</th>
                                    <th>Email</th>
                                    <th>Telefone</th>
                                    <th>Whatsapp</th>
                                    <th>Ações</th>
                                </tr>
                                </thead>
                                <tbody>
                                {comerciais.map((com) => (
                                    <tr key={com.id}>
                                    <td>{com.nome}</td>
                                    <td>{com.email}</td>
                                    <td>{com.telefone}</td>
                                    <td>{com.whatsapp_principal}</td>
                                    <td>
                                        <Button color="warning" size="sm" className="me-2" onClick={() => handleEditar(com)}>Editar</Button>
                                        <Button color="danger" size="sm" onClick={() => handleExcluir(com.id)}>Excluir</Button>
                                    </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                            )}
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>

      <Modal isOpen={modalAberto} toggle={() => setModalAberto(!modalAberto)} centered>
        <ModalHeader toggle={() => setModalAberto(!modalAberto)}>
          {editandoId ? 'Editar Comercial' : 'Novo Comercial'}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Nome</Label>
              <Input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome completo" />
            </FormGroup>
            <FormGroup>
              <Label>Email</Label>
              <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="exemplo@email.com" />
            </FormGroup>
            <FormGroup>
              <Label>Telefone</Label>
              <InputMask
                className="form-control"
                mask="(99) 99999-9999"
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
                placeholder="(00) 00000-0000"
              />
            </FormGroup>
            <FormGroup>
              <Label>Whatsapp</Label>
              <InputMask
                className="form-control"
                mask="(99) 99999-9999"
                value={whatsapp_principal}
                onChange={(e) => setWhatsapp(e.target.value)}
                placeholder="(00) 00000-0000"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalAberto(false)}>Cancelar</Button>
          <Button color="primary" onClick={handleSalvar}>{editandoId ? 'Atualizar' : 'Salvar'}</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
export default TelaComercialFeira;